import { useState } from 'react';
export const RadioComponent = ({ name, inititalValue, onChange, options, isValid, required,questionKey }) => {
  const [value, setValue] = useState(inititalValue);
  const onRadioChange = e => {
    setValue(e.target.value);
    onChange(e.target.name, e.target.value,questionKey, required);
  };
  return (
    <div>
    {options.map(option => {
         return  (<label className='form-field radio-label' key={option}>
            <input
            className={`radio-field ${required && !isValid ?'invalid-input':''}`}
              type="radio"
              name={name}
              value={option}
              checked={option === value}
              onChange={onRadioChange}
            />
            {option}
          </label>)
            })}
        { required && !isValid && <p className="validation-error">Field is required</p>}
          </div>
  );
};
